import { render, staticRenderFns } from "./ImsArbs.vue?vue&type=template&id=26db7fd6&"
import script from "./ImsArbs.vue?vue&type=script&lang=js&"
export * from "./ImsArbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports